import { selectPlayerLevelFromXp } from "../balancingSelectors/selectBalancingXpLevels";
import { IdModal } from "../features/modals/IdModal";
import { PlayerRankingCategory } from "../features/ranking/PlayerRankingCategory";
import { IdLoca } from "../utils/i18n/IdLoca";
import { selectCoopLevelFromXp } from "./selectCoopInfo";
import { selectModalTabId } from "./selectModalTabId";
export var selectPlayerLevel = function (state) {
    return state.playerInfo ? state.playerInfo.level || 0 : 0;
};
export var selectAdventureLevel = function (state) {
    return state.playerInfo ? state.playerInfo.adventurerLevel || 0 : 0;
};
export var selectRankingLevelFromXp = function (state, xp) {
    var type = selectModalTabId(state, IdModal.PlayerRanking);
    switch (type) {
        // todo: uncomment when implementing adventurer ranking
        // case PlayerRankingCategory.AdventurerLevelRanking:
        //     return selectAdventurerLevelFromXp(state, xp);
        case PlayerRankingCategory.CoopLevelRanking:
            return selectCoopLevelFromXp(xp);
        case PlayerRankingCategory.PlayerLevelRanking:
        default:
            return selectPlayerLevelFromXp(xp);
    }
};
export var selectRankingSearchNotFoundTextLoca = function (state) {
    var type = selectModalTabId(state, IdModal.PlayerRanking);
    switch (type) {
        // todo: uncomment when implementing adventurer ranking
        // case PlayerRankingCategory.AdventurerLevelRanking:
        //     return selectAdventurerLevelFromXp(state, xp);
        case PlayerRankingCategory.CoopLevelRanking:
            return IdLoca.floatingText_coopNotFound;
        case PlayerRankingCategory.PlayerLevelRanking:
        default:
            return IdLoca.floatingText_playerNotFound;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectPlayerLevelInfo.ts
// module id = 57
// module chunks = 3